import React, {useState, useEffect, useRef, useContext } from 'react';
import ReactDOM from 'react-dom';
import {MapContext} from '_context/MapContext';

const Slider = (props) => {
    const [sliderValue, setSliderValue] = useState('100%');
    const [unitNameShow, setUnitNameShow] = useState('none');
    const track = useRef(null);
    const [trackOneHeight, settTrackOneHeight] = useState(100/13);
    const {ktMapIns} = useContext(MapContext);

    useEffect(() => {
        if(ktMapIns){
            ktMapIns.onEvent('zoom_changed', function (event, payload) {
                ktMapIns.getZoom()
                let level = ktMapIns.getZoom()
                if(level==13){
                    setSliderValue('0%')
                }else{
                    setSliderValue((100-(level*trackOneHeight)) + '%')
                }
            });
        }
 
    }, [ktMapIns]);

    useEffect(() => {
        if(ktMapIns && ktMapIns.setZoom){
            ktMapIns.setZoom(13-Math.round(parseInt(sliderValue)/trackOneHeight))
        }
    }, [sliderValue]);

    let boxMin = 0, boxMax = 0, boxHeight;
    const dragMouseDown = (e)=>{
        boxHeight = e.target.parentElement.clientHeight;
        boxMin = e.target.parentElement.getBoundingClientRect().top;
        boxMax = boxMin + boxHeight;
        e = e || window.event;
        e.preventDefault();
        document.onmouseup = closeDragElement;
        document.onmousemove = elementDrag;
    }

    const elementDrag = (e)=>{
        e = e || window.event;
        e.preventDefault();
        if(e.clientY>boxMin && e.clientY<boxMax){
            setSliderValue(calcSliderVal(((e.clientY-boxMin)/ boxHeight) * 100) + '%')
        }else if (e.clientY>boxMax){
            setSliderValue('100%')
        }else{
            setSliderValue('0%')
        }  
    }

    const closeDragElement = (e)=>{
        document.onmouseup = null;
        document.onmousemove = null;
    }

    const trackClick = (e)=>{
        boxHeight = track.current.clientHeight;
        boxMin = track.current.getBoundingClientRect().top;
        boxMax = boxMin + boxHeight;
        if(e.clientY>boxMin && e.clientY<boxMax){
            setSliderValue(calcSliderVal(((e.clientY-boxMin)/ boxHeight) * 100) + '%')
        }else if (e.clientY>boxMax){
            setSliderValue('100%')
        }else{
            setSliderValue('0%')
        }      
    }

    const calcSliderVal = (value)=>{
        let checkVal = 0
        while(true){
            if(Math.abs(value-(checkVal*trackOneHeight))<trackOneHeight){
                let val = checkVal * trackOneHeight
                if(val>100){
                    val = 100;
                }
                return val;
            }
            checkVal++;
            if(checkVal>13){
                return 100;
            }
        }
    }

    return (
        <div className="wrapZoom" style={{zIndex:98, bottom:34}}>
            <div className="btnsZoom open">
                <button className="btnsBg btnZoomIn" onClick={(e) => ktMapIns.setZoom(ktMapIns.getZoom()+1)}>확대</button>
                <div className="scaleWrap" ref={track} style={{display:'block'}} 
                    onClick={(e) => trackClick(e)} onMouseOver={(e) => setUnitNameShow('block')} onMouseOut={(e) => setUnitNameShow('none')}>
                    <div className="current" style={{top:sliderValue}} onMouseDown={(e) => dragMouseDown(e)}></div>
                    <div className="unitName" style={{display:unitNameShow}}>
                        <span className="btnsBg">새주소</span>
                        <span className="btnsBg">거리</span>
                        <span className="btnsBg">동,리</span>
                        <span className="btnsBg">시군구</span>
                        <span className="btnsBg">도</span>
                        <span className="btnsBg">전국</span>
                    </div>
                </div>
                <button className="btnsBg btnZoomOut" onClick={(e) => ktMapIns.setZoom(ktMapIns.getZoom()-1)}>축소</button>
            </div>
        </div>
    );
}

export default Slider;